import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import Symbol from "slotworks/components/matrix/symbol/symbol-component";
import graphicsManager from "slotworks/graphics/graphics-manager";
import slotDefinition from "slotworks/model/slot-definition";
import { offsetPosition } from "slotworks/utils/position-offset-calculator";

/**
 * This behaviour can add an image to the MatrixContent layer in the PSD
 * called "${symbolName}_dim" if the dim image is a different size to it's host
 * static.
 *
 * @class ImageDimSymbolBehaviour
 */
export default class ImageDimSymbolBehaviour extends AbstractSymbolBehaviour {

    public behaviourName: string = "ImageDim";

    constructor(symbol: Symbol) {
        super(symbol);
        this.behaviourSprite = new PIXI.Sprite();
        this.behaviourSprite.name = "imageDim";
        this.matrixLayer.add(this.behaviourSprite);
    }

    public static() {
        super.static();
        this.behaviourSprite.visible = false;
        this.symbol.setVisible(true);
    }

    public winDim() {
        this.showDimTexture();
        return super.winDim();
    }

    public cycleDim() {
        this.showDimTexture();
        return super.cycleDim();
    }

    public highlightDim() {
        this.showDimTexture();
        return super.highlightDim();
    }

    public updateTransform() {
        super.updateTransform();

        const positions = [`${this.symbol.symbolId}_dim`, this.symbol.symbolId];
        offsetPosition(this.behaviourSprite, this.matrixLayer, "symbol_1_1", positions);
    }

    protected showDimTexture() {
        this.symbol.setVisible(false);

        this.behaviourSprite.texture = graphicsManager.getTexture(`${this.symbol.symbolId}_b`);
        this.behaviourSprite.visible = true;

        const symbolDefinition = slotDefinition.getSymbolDefinition(this.symbol.symbolId);

        const container = this.behaviourSprite.parent;
        for (let childIndex = container.children.length - 1; childIndex >= 0; childIndex--) {
            const child = container.children[childIndex];
            if (child.name === "imageDim") {

                if (symbolDefinition.alwaysOnTop) {
                    container.addChildAt(this.behaviourSprite, childIndex + 1);
                    break;
                } else {
                    container.addChildAt(this.behaviourSprite, childIndex);
                }
            }
        }

        this.updateTransform();
    }
}
